<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('usdttb.title')}}</div>
             <img class="link" src="@/assets/jilu.png" @click="link" alt="">
        </div>
        <div class="bg">
            <router-link class="select-box" to="/selectBz" tag="ul">
                <li class="t1">{{currency}}</li>
                <li class="t2">{{this.$t('chongbi.xzbz')}}</li>
                <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
            <ul class="list-box">
                <li class="list" v-show="currency == 'USDT'">
                    <div class="list-text">{{this.$t('chongbi.lianmc')}}</div>
                </li>
                <ul class="tab-box" v-show="currency == 'USDT'">
                    <li class="tab" :class="{active: curIdx == index}" @click="tab(index,item.value)" v-for="(item,index) in addressList" :key="index">{{item.value}}</li>
                </ul>
                <!-- 提币地址 -->
                <li class="list">
                    <div class="list-text">{{this.$t('usdttb.tbdz')}}</div>
                    <div class="input-box">
                        <input class="input" type="text" v-model="address" :placeholder="this.$t('usdttb.qsrtbdz')" autocomplete="off">
                    </div>
                </li>
                <!-- 提币数量 -->
                <li class="list">
                    <div class="list-text">{{this.$t('usdttb.tbsl')}}</div>
                    <div class="input-box">
                        <input class="input" type="number" v-model="money" min="0" @keyup ="keyMoney()" :placeholder="$t('usdttb.zdtb') + ' ' + c_tb_money" @change="changeMoney($event)" autocomplete="off">
                    </div>
                </li>
                 <!-- 手续费 -->
                <li class="list">
                    <div class="list-text">{{this.$t('jghy.sxfl')}}</div>
                    <input class="input input-sxf" type="text" v-model="withdraw_rate" readonly disabled>
                </li>
                 <!-- 到账数量 -->
                <li class="list">
                    <div class="list-text">{{this.$t('usdttb.dzsl')}}</div>
                    <input class="input input-num" type="number" v-model="countNum" readonly disabled>
                </li>
            </ul>
        </div>
        <div class="btn-box">
            <button class="btn" type="button" @click="sure">{{this.$t('usdttb.qd')}}</button>
        </div>
        <div class="mask" v-show="isMask"></div>
        <div class="alert-box" v-show="isShow">
            <div class="alert-head">{{$t('usdttb.qsrjymm')}}</div>
            <img class="close" src="@/assets/close.png" @click="close" alt="">
            <ul class="pwd-box">
                <li class="pwd" v-for="(item,index) in inputList" :key="index"><input class="input pwd-input" v-model="item.val" type="password" maxlength="1" oninput = "value=value.replace(/[^\d]/g,'')" @keyup="nextFocus($event,index)" inputmode="numeric" autocomplete="off"></li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'withdraw',
    data () {
        return {
            uid: '',
            token: '',
            curIdx: 0,
            hasLmc: false,
            isShow: false,
            isMask: false,
            isPay: false,
            usdtInfo: {},
            addressList: [],
            address: '',
            chain: '',
            money: '',
            amount: '',
            password:'',
            true_money: '',
            true_amount: '',
            withdraw_rate: '',//手续费
            c_tb_money: '', //最低提币
            currency: 'USDC',
            type: 1,
            chain_id: 1,
            yszPwd: true,
            inputList: [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}],
        }
    },
    created(){
         this.currency = localStorage.getItem('tbBzName') || 'USDC';
    },
    mounted(){
        this.token = localStorage.getItem('token');
        this.getWalletLine();
        this.getChainList();
    },
    methods: {
      hasTpassword(){
        this.$ajax.get('/web/hasTpassword',{}).then((res) => {
            let resData = res.data.data;
            if(resData == 0){
                this.yszPwd = false;
                return;
            }else{
                this.yszPwd = true
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      getWalletLine(){
          let params = {
              currency: this.currency
          }
          this.$ajax.get('/web/getWalletLine',{params}).then((res) => {
              let resData = res.data.data;
              if(res.data.code == 1000){
                this.$router.push('/index');
                return false
              }
              this.c_tb_money = resData.c_tb_money;
              this.withdraw_rate = resData.rate + '%';
          }).catch(function(err){
              console.log(err)
          })
      },
    keyMoney(){
			this.money = this.money.replace(/[^\d.]/g, "");  //仅保留数字和"."
			this.money = this.money.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
			this.money = this.money.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
			this.money = this.money.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
			if (this.money.indexOf(".") < 0 && this.money != "") { //首位是0的话去掉
				this.money = parseFloat(this.money);
			}
    },
    keyAmount(){
			this.amount = this.amount.replace(/[^\d.]/g, "");  //仅保留数字和"."
			this.amount = this.amount.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
			this.amount = this.amount.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
			this.amount = this.amount.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
			if (this.amount.indexOf(".") < 0 && this.amount != "") { //首位是0的话去掉
				this.amount = parseFloat(this.amount);
			}
		},
    getChainList(){
      let params = {
          currency: this.currency
      }
      this.$ajax.get('/web/getChainList',{params}).then((res) => {
          let resData = res.data.data;
          if(resData.length > 0){
              this.addressList = resData;
              this.chain = resData[0].value;
          }
      }).catch(function(err){
          console.log(err)
      })
    },
        tab(id,currency){
            this.curIdx = id;
            this.chain = chain;
        },
        nextFocus(el,index) {
            var dom = document.getElementsByClassName("pwd-input"),
                currInput = dom[index],
                nextInput = dom[index + 1],
                lastInput = dom[index - 1];
            /*这里的keyCode 根据不同的平台或许不同,安卓就是不是8*/
            if (el.keyCode != 8) {
                if (index < (this.inputList.length - 1)) {
                    nextInput.focus();
                } else {
                    currInput.blur();
                }
            }else{
                if (index != 0) {
                    lastInput.focus();
                }
            }
            let password = this.inputList[0].val +  this.inputList[1].val + this.inputList[2].val + this.inputList[3].val +  this.inputList[4].val + this.inputList[5].val;
            if(password.length == 6){
                let params = {
                      currency: this.currency,
                      address: this.address,
                      number: this.money,
                      password: password,
                      wid: '',
                      type: this.type,
                      chain: this.chain,
                }
                this.$ajax.post('/web/tokeMoney',params).then((res) => {
                  let resData = res.data;
                  if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                      this.$toast.center(this.$t('status.statusText')[2]);
                      setTimeout(() => {
                        this.count = 1;
                        this.$router.push({ path: '/tbjl', query: { idx: 1 } })
                      }, 1000)
                  }else{
                    this.count = 1;
                    this.isShow = this.isMask = true;
                    this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
                    this.$toast.center(resData.message);
                    return;
                  }
              }).catch(function(err){
                  console.log(err)
              })
            }else{
                return false;
            }
        },
        sure(){
            let reg=/^\d{6}$/;
            if(this.address == '' || this.address == null){
                this.$toast.center(this.$t('usdttb.qsrtbdz'));
                return;
            }
            if(this.money == '' || this.money == null){
                this.$toast.center(this.$t('usdttb.zdtb') + " " + this.c_tb_money);
                this.money = '';
                return false;
            }
            if(parseFloat(this.money) < parseFloat(this.c_tb_money)){
                this.$toast.center(this.$t('usdttb.zdtb') + " " +  this.c_tb_money);
                this.money = '';
                return false;
            }
            let params = {
              currency: this.currency,
              address: this.address,
              number: this.money,
              password: '',
              wid: '',
              type: this.type,
              chain: this.chain,
            }
            this.$ajax.post('/web/tokeMoney',params).then((res) => {
              let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                  this.$toast.center(this.$t('status.statusText')[2]);
                  setTimeout(() => {
                    this.count = 1;
                    this.$router.push({ path: '/tbjl', query: { idx: 1 } })
                  }, 1000)
              }else{
                this.count = 1;
                this.isShow = this.isMask = false;
                this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
                this.$toast.center(resData.message);
                return;
              }
          }).catch(function(err){
              console.log(err)
          })
        },
        close(){
            this.isShow = false;
            this.isMask = false;
        },
        goBack(){
            this.$router.push('/index')
        },
        link(){
            this.$router.push('/tbjl?idx=1');
        },
        changeMoney(e){
            this.money = e.target.value;
            let walletLine = parseFloat(this.withdraw_rate);
            if(this.money == '' || this.money == null){
                return false;
            }else if(Number(parseFloat(this.money) - (Number(parseFloat(this.money)) * walletLine/100)) <= 0){
                this.$toast.center(this.$t('usdttb.zdtb') + this.c_tb_money);
                this.money = '';
                return false;
            }else if(Number(parseFloat(this.money) - (Number(parseFloat(this.money)) * walletLine/100)) > 0){
                if(parseFloat(this.money) < parseFloat(this.c_tb_money)){
                    this.$toast.center(this.$t('usdttb.zdtb') + this.c_tb_money);
                    this.money = '';
                    return false;
                }else{
                    return this.true_money = (Number(parseFloat(this.money) - (Number(parseFloat(this.money)) * walletLine/100)).toFixed(4));
                }
            }
        }
    },
    computed: {
        countNum: function () {
            let walletLine = parseFloat(this.withdraw_rate);
            if(this.money == '' || this.money == null){
                return false;
            }else if(Number(parseFloat(this.money) - (Number(parseFloat(this.money)) * walletLine/100)) <= 0){
                return false;
            }else if(parseFloat(this.money) < parseFloat(this.c_tb_money)){
                return this.true_money = Number(parseFloat(this.money)) - (Number(parseFloat(this.money) * walletLine/100).toFixed(4));
            }else{
                return this.true_money = Number(parseFloat(this.money)) - (Number(parseFloat(this.money) * walletLine/100).toFixed(4));
            }
        },
        countMoney: function () {
            let walletLine = parseFloat(this.withdraw_rate);
            return this.true_money = (Number(this.money)-(Number(this.money)* walletLine/100)).toFixed(4);
        }
  }
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #666;
        font-size: .38rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .32rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: relative;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }
    .head .link{
        position: absolute;
        right: .24rem;
        top: .28rem;
        width: .6rem;
        height: .6rem;
    }
    .bg{
        position: absolute;
        top: 1.2rem;
        bottom: 1.3rem;
        width: 100%;
        height: auto;
        padding-bottom: .5rem;
        overflow-y: auto;
    }
    .select-box{
        display: flex;
        align-items: center;
        margin: 0 .24rem;
        padding: .5rem 0 .3rem;
        border-bottom: 1px solid #313a47;
    }
    .select-box .t1{
        flex: 1;
        color: #fff;
        font-size: .48rem;
    }
    .select-box .t2{
        padding-right: .24rem;
        color: #d2d2d2;
        font-size: .42rem;
    }
    .select-box .arrow{
        width: .24rem;
        height: .36rem;
    }
    .list-box{
        padding: 0 .24rem;
    }
    .tab-box{
        display: flex;
        justify-content: flex-start;
        flex-flow: wrap;
    }
    .tab-box .tab{
        position: relative;
        width: 30%;
        height: 1rem;
        color: #fff;
        font-size: .48rem;
        line-height: 1rem;
        margin: 0 .2rem .1rem 0;
        border-radius: 4px;
        background: rgba(70, 89, 148,.2);
        text-align: center;
    }
    .tab-box .tab.active::after{
        position: absolute;
		right: 0;
		bottom: 0;
		content: '';
		width: .72rem;
		height: .86rem;
		background: url('./../assets/Trend_Selected.png') no-repeat right center;
		background-size: .5rem .56rem;
    }
    .list-box .list{
        font-size: .48rem;
    }
    .list-box .list-text{
        padding: .5rem 0 .28rem;
        color: #ababab;
        font-size: .42rem;
    }
    .list-box .list-text .t1{
        color: #9b9b9b;
        font-size: .36rem;
    }
    .list-box .list .input{
        width: 100%;
        height: 1.2rem;
        padding: 0 .26rem;
        color: #d2d2d2;
        font-size: .42rem;
        line-height: 1.2rem;
        background: transparent;
        box-sizing: border-box;
        outline: none;
    }
    .list-box .list .input-sxf,.list-box .list .input-num{
        border-radius: .2rem;
        background: rgba(26, 36, 63,.5);
    }
    .list-box .select{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .1rem .26rem;
        color: #d0d0d0;
        font-size: .36rem;
        background: #1a243f;
        border-radius: .08;
    }
    .list-box .list .arrow{
		width: .36rem;
		height: .56rem;
	}
    .list-box .list .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 6px;
        border: 1px solid #515151;
    }
    .list-box .list .input-box .icon{
        width: .56rem;
        margin-right: .36rem;
    }
    .tips{
        padding: .5rem .24rem .4rem;
        color: #ababab;
        font-size: .36rem;
    }
    .tips-text{
        padding: 0 .24rem .2rem;
        color: #ababab;
        font-size: .36rem;
    }
    .btn-box{
        position: absolute;
        bottom: .52rem;
        width: 100%;
        padding: 0 .3rem;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
    .btn {
        width: 100%;
        height: 1.2rem;
        color: #fff;
        font-size: .42rem;
        line-height: 1.2rem;
        background: linear-gradient(left,  rgba(44, 170, 222, 0.5), rgba(93, 205, 233, 0.5));
        border-radius: .14rem;
        text-align: center;
    }
    .alert-box{
        position: absolute;
        left: .5rem;
        right: .5rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        padding: .26rem .46rem .68rem .46rem;
        background: rgba(55, 76, 124,.9);
        border-radius: .1rem;
        box-sizing: border-box;
        transform: translateY(-50%);
    }
    .alert-box .alert-head{
        position: relative;
        padding: 0 .06rem;
        color: #fff;
        font-size: .48rem;
        text-align: center;
    }
    .alert-box .close{
        position: absolute;
        right: .42rem;
        top: .42rem;
        width: .36rem;
        height: .36rem;
    }
    .alert-box .pwd-box{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: .5rem;
        border: 1px solid #fff;
    }
    .alert-box .pwd-box .pwd{
        flex: 1;
        height: 1rem;
    }
    .alert-box .pwd-box .pwd .input{
        width: 100%;
        height: 1rem;
        color: #fff;
        font-size: .52rem;
        font-weight: bold;
        border-right: 1px solid #fff;
        background: #374C7C;
        text-align: center;
        border-radius: 0;
        outline: none;
        box-sizing: border-box;
    }
    .alert-box .pwd-box .pwd:last-child .input{
        border-right: none;
    }
    .alert-wrap{
        position: absolute;
        left: 1.3rem;
        right: 1.18rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        background: #1A2440;
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-wrap .alert-head,.alert-wrap2 .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .48rem;
        text-align: center;
    }
    .alert-wrap .alert-head .icon,.alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .42rem;
        top: .42rem;
        width: .42rem;
        height: .42rem;
    }
    .alert-wrap .cont{
        max-height: 6rem;
        padding: 0 .8rem .72rem .72rem;
        color: #fff;
        font-size: .48rem;
        overflow: auto;
    }
    .alert-pay{
        background: #1a243f;
    }
    .alert-pay .alert-head{
        padding: .5rem .4rem;
        font-size: .48rem;
        border-bottom: 1px solid #858585;
    }
    .alert-pay .alert-btn{
        padding: .3rem 0;
        color: #2CAADE;
        font-size: .42rem;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/withdraw.vue